var v4_customData={};
try {
    v4_customData={
      currency: ShopifyAnalytics.meta.currency,
      pageType: ShopifyAnalytics.meta.page.pageType
    };
    Shopify.analytics.publish("sce_page_init", v4_customData); 
  } catch (error) {};
window.dataLayer = window.dataLayer || [];
$(function () {
  // 判断是否在可视区域
   var GAiiv = function isInView(o) {
          typeof o[0] === 'undefined' ? o = o : o = o[0];
          if (o instanceof HTMLElement) {
              var vph = window.innerHeight, wpw = window.innerWidth;
              var oRect = o.getBoundingClientRect();
              var ott = oRect.top + oRect.height * 0.5;
              var otl = oRect.left + oRect.width * 0.5;
              return (ott > 0 && ott < vph && otl > 0 && otl < wpw);
          } else { return false; }
 }
  // 通过防抖可以控制函数在一定时间间隔内只执行一次
    var GAgdb = function gaDebounce(fn, wait) {
          var timeout = null;
          return function () {
              if (timeout !== null) { clearTimeout(timeout); }
              timeout = setTimeout(fn, wait);
          }
 }
    // 储存操作浏览器的本地存储
    function sendLocalProinfo(promitionid,promoname){
      var ga_prInfo=localStorage.getItem("ga_prInfo");
      if(ga_prInfo){
          localStorage.removeItem("ga_prInfo");
      }
            localStorage.setItem('ga_prInfo',JSON.stringify({
                    ts: Date.now()+3600*24*30*1000,
                    promotion_id: promitionid, 
                    promotion_name: promoname
                    }));
}
// 收集页面特定区域内首张图片的相关信息
 function sendImgprodata(imgflag,sectionid,promotionid){
      var hotObj= document.getElementById(sectionid);
      var topimg = hotObj.getElementsByTagName("img")[0];
      var topimgsrc = topimg.getAttribute("src");
      var topimgalt = topimg.getAttribute("alt");
     if(GAiiv(hotObj)&&!imgflag[topimgalt]){
         // console.log(topimgsrc+"******"+topimgalt);
          // view_promotion 
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "dle_view_promotion",
          ecommerce: {
          items: [{
            item_name: topimgalt,
            item_id: promotionid,
            promotion_id: promotionid,
            promotion_name: topimgalt,
            creative_name: topimgsrc,
            creative_slot: `0`
          }]
        }
      });
       imgflag[topimgalt] = true;
    }
  }
// 处理用户点击特定区域
function sendClickproid(sectionid,promotionid){
    var hotObj= document.getElementById(sectionid);
    var topimg = hotObj.getElementsByTagName("img")[0];
    var topimgsrc = topimg.getAttribute("src");
    var topimgalt = topimg.getAttribute("alt");
      var promoname =topimgalt;
      sendLocalPromotion(promotionid,promoname);
        // select_promotion 
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "dle_select_promotion",
        ecommerce: {
          items: [{
            item_name: topimgalt,
            item_id: promotionid,
            promotion_id: promotionid,
            promotion_name: topimgalt,
            creative_name: topimgsrc,
            creative_slot: `0`
          }]
        }
    })
  }
// swiper点击传参
function sendSwiperClickdata(aSrc,aAlt,index,curmypage){
                          var imgitems=new Array();
                           var csl=index;
                          if(curmypage.includes('/black-friday-sale')){
                            var iid = "pageBFsale_swiper-slide-banner_image";
                            var pid = "pageBFsale_swiper-slide-banner_image";
                          }else{
                            var iid = "homepage_swiper-slide-banner_image";
                            var pid = "homepage_swiper-slide-banner_image";
                          }
                          imgitems.push({
                               "item_id": iid,
                               "item_name": aAlt,
                               "promotion_id": pid,
                               "promotion_name": aAlt,
                               "creative_name": aSrc,
                               "creative_slot": csl
                            });
                       if(imgitems.length>0){
                          dataLayer.push({ ecommerce: null });
                          dataLayer.push({
                            "event": "dle_select_promotion",
                            "ecommerce": {
                              "items": imgitems
                          }
                        });
                      };
  }
// swiper展示传参
function sendSwiperViewdata(aSrc,aAlt,index,curmypage){
                           var imgitems=new Array();
                           var csl=index;
                          if(curmypage.includes('/black-friday-sale')){
                            var iid = "pageBFsale_swiper-slide-banner_image";
                            var pid = "pageBFsale_swiper-slide-banner_image";
                          }else{
                            var iid = "homepage_swiper-slide-banner_image";
                            var pid = "homepage_swiper-slide-banner_image";
                          }
                          imgitems.push({
                               "item_id": iid,
                               "item_name": aAlt,
                               "promotion_id": pid,
                               "promotion_name": aAlt,
                               "creative_name": aSrc,
                               "creative_slot": csl
                            });
                       if(imgitems.length>0){
                          dataLayer.push({ ecommerce: null });
                          dataLayer.push({
                            "event": "dle_view_promotion",
                            "ecommerce": {
                              "items": imgitems
                          }
                        });
                      };
  }

// 展示Announcement slider
    $('.announcement-bar__list .announcement-bar__item').each(function (index, element) {
        var aElem = $(this).find('a');
        var ahref = '';
        var ptext = '';
        if (aElem.length > 0 ) {
            ahref = aElem.attr('href');
            ptext = $(this).find('p').text();
        }

        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "dle_view_promotion",
          ecommerce: {
          items: [{
              item_name: ptext,
              item_id: `homepage_top-banner_image`,
              promotion_id: `homepage_top-banner_image`,
              promotion_name: ptext,
              creative_name: ahref,
              creative_slot: index,
            }]
          }
        });
    });
  // 点击Announcement slider
   var allLinks = $(".announcement-bar__list .announcement-bar__item a");
      allLinks.click(function () {
        var index = allLinks.index($(this));
        var cptext = $(this).text();
        var cahref = $(this).attr('href');
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "dle_select_promotion",
          ecommerce: {
          items: [{
              item_name: cptext,
              item_id: `homepage_top-banner_image`,
              promotion_id: `homepage_top-banner_image`,
              promotion_name: cptext,
              creative_name: cahref,
              creative_slot: index,
            }]
          }
        });
      });
  // about banner 展示触发
  var boneflag ={};
  function viewHomeadone(){
    var promotionid = "homepage_about_us";
    var hotObj = $("#about_timeline__item");
    var ussrc =$("#about_timeline__item .timeline__content .button--primary").attr("href");
    var ustext =$("#about_timeline__item .timeline__content .heading ").text();
    if(GAiiv(hotObj)&&!boneflag[ustext]){
          // view_promotion 
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "dle_view_promotion",
          ecommerce: {
          items: [{
            item_name: ustext,
            item_id: promotionid,
            promotion_id: promotionid,
            promotion_name: ustext,
            creative_name: ussrc,
            creative_slot: `0`
          }]
        }
      });
       boneflag[ustext] = true;
    }
  }
  $(window).scroll(GAgdb(viewHomeadone, 1000));
   //about banner 点击触发
  $("#about_timeline__item .timeline__content .button--primary").click(function(){
      var promotionid = "homepage_about_us";
      var hotObj = $("#about_timeline__item");
      var ussrc =$("#about_timeline__item .timeline__content .button--primary").attr("href");
      var ustext =$("#about_timeline__item .timeline__content .heading ").text();
      sendLocalProinfo(promotionid,ustext);
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: "dle_select_promotion",
            ecommerce: {
            items: [{
              item_name: ustext,
              item_id: promotionid,
              promotion_id: promotionid,
              promotion_name: ustext,
              creative_name: ussrc,
              creative_slot: `0`
            }]
          }
        });
  })
// 轮播banner开始
var flag = {};
var mycurpage = window.location.href;
    var mySwiper = new Swiper('#pcSwiper', {
  // Optional parameters
    direction: 'horizontal',
    loop: true,
    autoplay: {
		delay: 5000,
		disableOnInteraction: false,
    },
    slidesPerView: 1,
    spaceBetween: 0,
    // If we need pagination
    pagination: {
    el: '.swiper-pagination',
    clickable:true,
    },

  // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on:{
        slideChangeTransitionEnd:function(event){
          var pcswiperCon = document.getElementById("pcSwiper");
          if(GAiiv(pcswiperCon)){  
            var img_index = this.realIndex;
            var currentSlide = this.slides[img_index];
            var aTag = currentSlide.querySelector('img');
            if (aTag) {
              var aSrc = aTag.src;
              var aAlt = aTag.alt;;
              if(flag[img_index] !== img_index){
                    sendSwiperViewdata(aSrc,aAlt,img_index,mycurpage);
                    flag[img_index] = img_index;
                }
              }
          } 
        }
      } 
  })
  $("#pcSwiper .swiper-slide").click(function(){
    var indexReal = mySwiper.realIndex;
    var currentSlide = mySwiper.slides[indexReal];
    var aTag = currentSlide.querySelector('img');
    if (aTag) {
            if(mycurpage.includes('/black-friday-sale')){
              var promotionid ="pageBFsale_swiper-slide-banner_image";
            }else{
               var promotionid ="homepage_swiper-slide-banner_image";
            }
            var aAlt ="";
            var aSrc = aTag.src;
            var aAlt = aTag.alt;
               if(aAlt == "" || aAlt == null){
                 aAlt = "Swiper Slide IMG"+indexReal;
              }
              sendLocalProinfo(promotionid,aAlt);
              sendSwiperClickdata(aSrc,aAlt,indexReal,mycurpage);
          } 
})
  var moflag ={};
  var momySwiper = new Swiper('#mobSwiper', {
  // Optional parameters
    direction: 'horizontal',
  // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable:true,
    }, 
    loop: true,
    autoplay: {
		delay: 5000,
		disableOnInteraction: false,
    },
    on:{
        slideChangeTransitionEnd:function(event){
        var mobSwiper = document.getElementById("mobSwiper");
        if(GAiiv(mobSwiper)){  
          var img_index = this.realIndex;
          var currentSlide = this.slides[img_index];
          var aTag = currentSlide.querySelector('img');
          if (aTag) {
            var aSrc = aTag.src;
            var aAlt = aTag.alt;;
          
            if(moflag[img_index] !== img_index){
                  sendSwiperViewdata(aSrc,aAlt,img_index,mycurpage);
                  moflag[img_index] = img_index;
              }
            }
          } 
        }
      }
  })
    $("#mobSwiper .swiper-slide").click(function(){
      var indexReal = momySwiper.realIndex;
      var currentSlide = momySwiper.slides[indexReal];
      var aTag = currentSlide.querySelector('img');
      if (aTag) {
            if(mycurpage.includes('/black-friday-sale')){
              var promotionid ="pageBFsale_swiper-slide-banner_image";
            }else{
               var promotionid ="homepage_swiper-slide-banner_image";
            }
            var aAlt ="";
            var aSrc = aTag.src;
            var aAlt = aTag.alt;
               if(aAlt == "" || aAlt == null){
                 aAlt = "Swiper Slide IMG"+indexReal;
              }
              sendLocalProinfo(promotionid,aAlt);
              sendSwiperClickdata(aSrc,aAlt,indexReal,mycurpage);
          }
  })
// 轮播banner结束
// 促销展示 Tablist products
// 获取大标题
function getSectionTit(strselection){
  
  if(window.location.href.includes('/products/')){
     var newlistname ="productpage_";
  }else{
     var newlistname ="homepage_";
  }
   var gettitname ="";
  gettitname = $(strselection).text().trim();
  gettitname = gettitname.replace(/\s+/g,'');
  newlistname = newlistname + gettitname;
  return newlistname;
}
// 多系列获取系利类目
function getTabstits(strselection){
    var gettitname="";
    gettitname = $(strselection).text().trim();
    gettitname = gettitname.replace(/\s+/g,'');
    gettitname = gettitname.toLowerCase();
  var newlistname = "homepage_"+ gettitname;
  return newlistname;
}
// 多系列得list拼接大标题和系列类目
function getTabstit(strselection,gettabtit){
    var gettitname="";
    gettitname = $(strselection).text().trim();
    gettitname = gettitname.replace(/\s+/g,'');
  var newlistname = gettabtit +"_" + gettitname;
  return newlistname;
}
// 促销 Products 展示触发函数
  function viewHomelists(cxClass,proflag,cxclassTit){
    var proitems=new Array();
    $(cxClass).each(function(){
           var protitleshow = $(this).find(".product-item-meta__title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
              product_realsku = "not set";
           }
           var propriceshow = $(this).find(".price--highlight .money").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
          var newblocktit = getSectionTit(cxclassTit);
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "homepage_bestseller_products";
                 }else{
                   var prolistname = newblocktit;
                 }
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           if(GAiiv($(this))&&proflag[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
              proflag[proindexshow] = proindexshow;
           }
    });
     if(proitems.length>0){
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
  }
// 储存数据
function sendProlistname(prolistname){
      var ga_ilInfo=localStorage.getItem("ga_ilInfo");
      if(ga_ilInfo){
          localStorage.removeItem("ga_ilInfo");
      }
           localStorage.setItem('ga_ilInfo',JSON.stringify({
                    ts: Date.now()+3600*24*30*1000,
                     item_list_name: prolistname
                    }));
}
// 释放删除ga_prInfo
function sendPromoinfo(){
       var ga_prInfo=localStorage.getItem("ga_prInfo");
      if(ga_prInfo){
          localStorage.removeItem("ga_prInfo");
      }
}
 // 使用 ga_prInfo
function getLocallistname(){
  var ga_ilInfo=localStorage.getItem("ga_ilInfo");
   var sitems=new Array(); 
  if(ga_prInfo){
    var obj=JSON.parse(ga_ilInfo)
    if(obj.ts>Date.now()){
        last_ilnm=obj.item_list_name;
        sitems.push(last_ilnm);
    }
    return sitems;
  }
}
  // 向ga_prInfo添加数据
  function sendProindex(productid,listname,index){
                 var ga_proIndex=localStorage.getItem("ga_proIndex");
                 if(ga_proIndex){
                      var proflag =0;
                      var objArrs=JSON.parse(ga_proIndex);
                      for(var i=0;i<objArrs.length;i++){
                        var objInfos = objArrs[i];
                        if(objInfos.productid == productid && objInfos.prolistname == listname){
                            objArrs.splice(i,1);   
                          var arrInfos = {
                              productid: productid,
                              prolistname: listname,
                              proindex: index,
                              ts: Date.now()+3600*24*30*1000
                            };
                            objArrs.push(arrInfos);
                            localStorage.setItem('ga_proIndex',JSON.stringify(objArrs));
                           break;
                        }else{
                          proflag++;
                        }
                    }
                    if(proflag == objArrs.length){
                       var arrInfos = {
                               productid: productid,
                               prolistname: listname,
                               proindex: index,
                               ts: Date.now()+3600*24*30*1000
                            };
                            objArrs.push(arrInfos);
                            localStorage.setItem('ga_proIndex',JSON.stringify(objArrs));
                    }
                 }else{
                      var proArray = new Array();
                      var arrInfo = {
                             productid: productid,
                             prolistname: listname,
                             proindex: index,
                             ts: Date.now()+3600*24*30*1000
                            };
                       proArray.push(arrInfo);
                     localStorage.setItem('ga_proIndex',JSON.stringify(proArray));
                 }
  }
// 促销 Products 点击触发函数
  function clickProGaList(thisobj,cxclassTit){
                  var protitleshow = $(thisobj).find(".product-item-meta__title").text();
                   var proidshow = $(thisobj).find(".productid_ga4").text();
                   var product_sku = $(thisobj).find(".productsku_ga4").text();
                   var product_realsku = $(thisobj).find(".productsku2_ga4").text();
                   if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
                      product_realsku = "not set";
                   }
                   var propriceshow = $(thisobj).find(".price--highlight .money").text().replace(/[^0-9.]/g, '');
                   var provariantshow = $(thisobj).find(".productvariant_ga4").text();
                  var newblocktit = getSectionTit(cxclassTit);
                         if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                           var prolistname = "homepage_bestseller_products";
                         }else{
                           var prolistname = newblocktit;
                         }
                   var proindexshow = $(thisobj).index();
                   var proquantityshow = 1;
                   var procurrencyshow = "USD";
                   var procategoryshow = $(thisobj).find(".productcategory_ga4").text();
                  sendProlistname(prolistname);
                  sendProindex(proidshow,prolistname,proindexshow);
                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_item",
                      "ecommerce": {
                        "items": [{
                              "item_id": proidshow,
                               "item_name": protitleshow,
                               "product_sku": product_realsku,
                               "price": propriceshow,
                               "item_category": procategoryshow,
                               "item_variant": provariantshow,
                               "item_list_name": prolistname,
                               "index": proindexshow,
                               "quantity": proquantityshow,
                               "currency": procurrencyshow
                        }]
                      }
                  })
  }
  // best seller 展示触发
    var hotflag={};
   function viewprohotHandle(){
     var cxclass="#homepage-best-sellers .product-list__inner  .product-item"
     var cxclassTit="#homepage-best-sellers .p_text-container .p_heading";
       viewHomelists(cxclass,hotflag,cxclassTit);
   }
   window.addEventListener('scroll', GAgdb(viewprohotHandle,1000));

  // best seller 点击触发
  $("#homepage-best-sellers .product-list__inner  .product-item").click(function(){
     var cxclassTit="#homepage-best-sellers .p_text-container .p_heading";
     clickProGaList(this,cxclassTit);
  }); 

  // New Arrival  展示触发
    var newflag={};
   function viewpronewHandle(){
     var cxclass="#homepage-new-arrival .product-list__inner  .product-item"
     var cxclassTit="#homepage-new-arrival .p_text-container .p_heading";
       viewHomelists(cxclass,newflag,cxclassTit);
   }
   window.addEventListener('scroll', GAgdb(viewpronewHandle,1000));

     // New Arrival 点击触发
  $("#homepage-new-arrival .product-list__inner  .product-item").click(function(){
     var cxclassTit="#homepage-new-arrival .p_text-container .p_heading";
     clickProGaList(this,cxclassTit);
  }); 


  // Recommend  展示触发
    var recomflag={};
   function viewprorecHandle(){
     var cxclass="#homepage-recommend .product-list__inner  .product-item"
     var cxclassTit="#homepage-recommend .p_text-container .p_heading";
       viewHomelists(cxclass,recomflag,cxclassTit);
   }
   window.addEventListener('scroll', GAgdb(viewprorecHandle,1000));

     //Recommend  展示触发 点击触发
  $("#homepage-recommend .product-list__inner  .product-item").click(function(){
     var cxclassTit="#homepage-recommend .p_text-container .p_heading";
     clickProGaList(this,cxclassTit);
  }); 


  // PC flash sale 展示触发
  var flashflag={};
  function viewproflashHandle(){
    var cxclass="#homepage_flashsale-container .pc-home-flash .swiper-slide.today-special_item";
    var cxclassTit="#homepage_flashsale-container .home-flashTit_title";
    viewHomelists(cxclass,flashflag,cxclassTit);
  }
 window.addEventListener('scroll', GAgdb(viewproflashHandle,1000));
  // PC flash sale 点击触发
  $("#homepage_flashsale-container .pc-home-flash .swiper-slide.today-special_item").click(function(){
          var cxclassTit="#homepage_flashsale-container .home-flashTit_title";
              clickProGaList(this,cxclassTit);
     }); 

// mobile flash sale 展示触发
  var flashflag={};
  function viewproflashHandle(){
    var cxclass="#homepage_flashsale-container .m-home-flashsale .product-wheel_item";
    var cxclassTit="#homepage_flashsale-container .home-flashTit_title";
    viewHomelists(cxclass,flashflag,cxclassTit);
  }
 window.addEventListener('scroll', GAgdb(viewproflashHandle,1000));
  // mobile flash sale 点击触发
  $("#homepage_flashsale-container .m-home-flashsale .product-wheel_item").click(function(){
          var cxclassTit="#homepage_flashsale-container .home-flashTit_title";
              clickProGaList(this,cxclassTit);
     }); 
  
// home ad bob wig banner
  var bobflag ={};
  function viewHomebob(){
    var imgitems=new Array();
    $("#home_banner-adbob .homeadimg_item").each(function(){
           var csl=$(this).index();
           var iid = "homepage_banner-ad_image";
           var pid = "homepage_banner-ad_image";
           var mobileadimg =  $(this).find('.mobile_show_banner-img').css('display')
           if (mobileadimg === 'none') {
              var cnm = $(this).find(".pc_show_banner-img").attr("src");
              var pnm = $(this).find(".pc_show_banner-img").attr("alt");
          } else {
              var cnm = $(this).find(".mobile_show_banner-img").attr("src");
              var pnm = $(this).find(".mobile_show_banner-img").attr("alt");    
          }
           if(GAiiv($(this))&&bobflag[csl] !== csl){
               imgitems.push({
                   "item_id": iid,
                   "item_name": pnm,
                   "promotion_id": pid,
                   "promotion_name": pnm,
                   "creative_name": cnm,
                   "creative_slot": csl
               }); 
               bobflag[csl] = csl
           }
    });
     if(imgitems.length>0){
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_promotion",
              "ecommerce": {
                "items": imgitems
              }
          })
       };
  }
  $(window).scroll(GAgdb(viewHomebob, 1000));
   //about banner 点击触发
  $("#home_banner-adbob .homeadimg_item").click(function(){
           var csl=$(this).index();
           var iid = "homepage_banner-ad_image";
           var pid = "homepage_banner-ad_image";
           var mobileadimg =  $(this).find('.mobile_show_banner-img').css('display')
           if (mobileadimg === 'none') {
              var cnm = $(this).find(".pc_show_banner-img").attr("src");
              var pnm = $(this).find(".pc_show_banner-img").attr("alt");
          } else {
              var cnm = $(this).find(".mobile_show_banner-img").attr("src");
              var pnm = $(this).find(".mobile_show_banner-img").attr("alt");    
          }
           var promotionid = pid;
          var promoname = pnm;
          sendLocalProinfo(promotionid,promoname);
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: "dle_select_promotion",
            ecommerce: {
            items: [{
                  "item_id": iid,
                   "item_name": pnm,
                   "promotion_id": pid,
                   "promotion_name": pnm,
                   "creative_name": cnm,
                   "creative_slot": csl
            }]
          }
        });
  })

// collections ga4 event  类目开始
if(window.location.href.includes('/collections/')) {
  function sendLocallistname(listname){
      var ga_ilInfo=localStorage.getItem("ga_ilInfo");
      if(ga_ilInfo){
          localStorage.removeItem("ga_ilInfo");
      }
            localStorage.setItem('ga_ilInfo',JSON.stringify({
                    ts: Date.now()+3600*24*30*1000,
                     item_list_name: listname
                    }));
}
    var collectflg={};
    // 获取页面第几页
    const urlParams = new URLSearchParams(window.location.search);
    const pageParam = urlParams.get('page');
    if (pageParam) {
        const pageNumber = parseInt(pageParam);
        if (!isNaN(pageNumber) && pageNumber > 0) {
            pagenum = pageNumber;
        }
    }else{
        pagenum = 1;
    }
// 列表页展示触发
  function viewCollectionlists(){
      var proitems=new Array();
      var prolistname = $('#getSeriesName .heading').text();
    $("#CollectionSection .product-list__inner .product-item").each(function(){
           var protitleshow = $(this).find(".product-item-meta__title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
              product_realsku = "not set";
           }
           var propriceshow = $(this).find(".price--highlight .money").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
           var proindexshow = $(this).index();
           proindexshow = (pagenum-1)*28+proindexshow;
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           if(GAiiv($(this))&&collectflg[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
               collectflg[proindexshow] = proindexshow;
           }
    });
     if(proitems.length>0){
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
  }
  window.addEventListener('scroll', GAgdb(viewCollectionlists,1000));
  
// 判断是否从首页来的函数
function isFromHomepage() {
    const HOMEPAGE_URL = 'https://www.pizazzhair.com/';
    return document.referrer === HOMEPAGE_URL;
}
// 处理 ga_cproInfo 的函数，添加参数接收
function processGaCproInfo(proidshow, prolistname, lastPromotionId, lastPromotionName) {
    try {
        const ga_cproInfo = localStorage.getItem('ga_cproInfo');
        let productInfoArray = [];
        if (ga_cproInfo) {
            productInfoArray = JSON.parse(ga_cproInfo);
        }

        const existingIndex = productInfoArray.findIndex(item => item.proid === proidshow);
        if (existingIndex!== -1) {
            productInfoArray.splice(existingIndex, 1);
        }

        const newProductInfo = {
            proid: proidshow,
            prolname: prolistname,
            promotionid: lastPromotionId,
            promotionname: lastPromotionName,
            ts: Date.now() + 3600 * 24 * 30 * 1000
        };
        productInfoArray.push(newProductInfo);

        localStorage.setItem('ga_cproInfo', JSON.stringify(productInfoArray));
    } catch (error) {
        console.error('处理 ga_cproInfo 时出错:', error);
    }
}

// 主函数，整合逻辑，添加参数接收
function handlePageData(proidshow, prolistname, lastPromotionId, lastPromotionName) {
    processGaCproInfo(proidshow, prolistname, lastPromotionId, lastPromotionName);
}
// 点击列表页系列触发
function handleItemClick() {
    var prolistname = $('#getSeriesName .heading').text();
    sendLocallistname(prolistname);
    var protitleshow = $(this).find(".product-item-meta__title").text();
    var proidshow = $(this).find(".productid_ga4").text();
    var product_sku = $(this).find(".productsku_ga4").text();
    var product_realsku = $(this).find(".productsku2_ga4").text();
    if (product_realsku == '' || product_realsku == null || product_realsku == undefined || product_realsku.length == 0) {
        product_realsku = "not set";
    }
    var propriceshow = $(this).find(".price--highlight .money").text().replace(/[^0-9.]/g, '');
    var provariantshow = $(this).find(".productvariant_ga4").text();
    var proindexshow = $(this).index();
    proindexshow = (pagenum - 1) * 28 + proindexshow;
    var proquantityshow = 1;
    var procurrencyshow = "USD";
    var procategoryshow = $(this).find(".productcategory_ga4").text();
    sendProindex(proidshow, prolistname, proindexshow);

    let lastPromotionId, lastPromotionName;
    if (isFromHomepage()) {  // 只有从首页进来时才进行相关处理
        const ga_prInfo = localStorage.getItem('ga_prInfo');
        if (ga_prInfo) {
            try {
                const obj = JSON.parse(ga_prInfo);
                if (obj.ts > Date.now()) {
                    lastPromotionId = obj.promotion_id;
                    lastPromotionName = obj.promotion_name;
                } else {
                    // 如果时间戳无效，删除ga_prInfo并将lastPromotionId和lastPromotionName设为undefined
                    localStorage.removeItem('ga_prInfo');
                    lastPromotionId = undefined;
                    lastPromotionName = undefined;
                }
            } catch (error) {
                // 解析出错时同样将lastPromotionId和lastPromotionName设为undefined
                lastPromotionId = undefined;
                lastPromotionName = undefined;
            }
        } else {
            // 如果ga_prInfo不存在，也将lastPromotionId和lastPromotionName设为undefined
            lastPromotionId = undefined;
            lastPromotionName = undefined;
        }
        handlePageData(proidshow, prolistname, lastPromotionId, lastPromotionName);
    }

    // 无论是否从首页来，都执行dataLayer.push相关操作
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
        "event": "dle_select_item",
        "ecommerce": {
            "items": [{
                "item_id": proidshow,
                "item_name": protitleshow,
                "product_sku": product_realsku,
                "price": propriceshow,
                "item_category": procategoryshow,
                "item_variant": provariantshow,
                "item_list_name": prolistname,
                "index": proindexshow,
                "quantity": proquantityshow,
                "currency": procurrencyshow
            }]
        }
    });
}

  $(document).ready(function () {
      $("#CollectionSection .product-list__inner .product-item").click(handleItemClick);
  });
}
// 产品页
if(window.location.href.includes('/products/')) {
// 底部推荐产品 展示触发
function handleProductData() {
  var protabtflag={};
  if($("#home-second-tablist .tablist_header1").hasClass("active")){
        var proitems=new Array();
        $("#home-second-tablist1 .product-list .product-item").each(function(){
           var protitleshow = $(this).find(".product-item-meta__title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
              product_realsku = "not set";
           }
           var propriceshow = $(this).find(".price--highlight .money").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
           var newblocktit = $("#home-second-tablist .tablist_header1").text();
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                     var prolistname = "product_Recommend";
                 }else{
                    newblocktit = newblocktit.trim().replace(/\s+/g,'')
                    var prolistname = "product_"+ newblocktit;
                 }
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           if(GAiiv($(this))&&protabtflag[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
             protabtflag[proindexshow] = proindexshow;
           }
    });
     if(proitems.length>0){
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
     }
}
window.addEventListener('scroll', GAgdb(handleProductData,1000))
  
    if($(".home-recommend_head .home-recommend_btn.col").length == 0){
        $(".home-recommend_head .home-recommend_btn:eq(0)").addClass("active");
        $('.home-recommend_proBox .recommend_pro-list:eq(0)').css('display','block');
    }
    // 点击小类别
    $(".home-recommend_head .home-recommend_btn").click(function(){
        $(this).addClass("active").siblings().removeClass("active");
        $(".home-recommend_proBox .recommend_pro-list").hide().eq($(this).index()).show();
        var clickindex = $(this).index();
        var taboneflag={};
        var tabtwoflag={};
        var tabthreeflag={};
        // 第一个系列
        if($("#home-second-tablist .tablist_header1").hasClass("active")){
        var proitems=new Array();
        $("#home-second-tablist1 .product-list .product-item").each(function(){
           var protitleshow = $(this).find(".product-item-meta__title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
              product_realsku = "not set";
           }
          
           var propriceshow = $(this).find(".price--highlight .money").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
           var newblocktit = $("#home-second-tablist .tablist_header1").text();
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                     var prolistname = "product_Recommend";
                 }else{
                    newblocktit = newblocktit.trim().replace(/\s+/g,'')
                    var prolistname = "productpage_"+ newblocktit;
                 }
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           if(taboneflag[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
              taboneflag[proindexshow] = proindexshow;
           }
    })
}
        // 第二个系列
        if($("#home-second-tablist .tablist_header2").hasClass("active")){
        var proitems=new Array();
        $("#home-second-tablist2 .product-list .product-item").each(function(){
           var protitleshow = $(this).find(".product-item-meta__title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
              product_realsku = "not set";
           }
          
           var propriceshow = $(this).find(".price--highlight .money").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
           var newblocktit = $("#home-second-tablist .tablist_header2").text();
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                     var prolistname = "product_Recommend";
                 }else{
                    newblocktit = newblocktit.trim().replace(/\s+/g,'')
                    var prolistname = "productpage_"+ newblocktit;
                 }
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           if(tabtwoflag[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
              tabtwoflag[proindexshow] = proindexshow;
           }
    })
}
         // 第三个系列
        if($("#home-second-tablist .tablist_header3").hasClass("active")){
        var proitems=new Array();
        $("#home-second-tablist3 .product-list .product-item").each(function(){
           var protitleshow = $(this).find(".product-item-meta__title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
              product_realsku = "not set";
           }
          
           var propriceshow = $(this).find(".price--highlight .money").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
           var newblocktit = $("#home-second-tablist .tablist_header3").text();
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                     var prolistname = "product_Recommend";
                 }else{
                    newblocktit = newblocktit.trim().replace(/\s+/g,'')
                    var prolistname = "productpage_"+ newblocktit;
                 }
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           if(tabthreeflag[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
              tabthreeflag[proindexshow] = proindexshow;
           }
    })
}
         if(proitems.length>0){
              dataLayer.push({ ecommerce: null });
              dataLayer.push({
                  "event": "dle_view_item_list",
                  "ecommerce": {
                    "items": proitems
                  }
              })
           };
  })

  // 产品推荐 点击触发
  $("#home-second-tablist1 .product-list .product-item").click(function(){
     var cxclassTit="#home-second-tablist .tablist_header1";
     clickProGaList(this,cxclassTit);
  }); 

  $("#home-second-tablist2 .product-list .product-item").click(function(){
     var cxclassTit="#home-second-tablist .tablist_header2";
     clickProGaList(this,cxclassTit);
  }); 

  $("#home-second-tablist3 .product-list .product-item").click(function(){
     var cxclassTit="#home-second-tablist .tablist_header3";
     clickProGaList(this,cxclassTit);
  }); 
}
if(window.location.href.includes('/cart')) {
    function getListCartname(productid,provarid){
          var ga_cartInfos=localStorage.getItem("ga_cartInfos");
           if(ga_cartInfos){
                      var objArr=JSON.parse(ga_cartInfos);
                      var flagno = 0;
                     var flagtwo = 0;
                      for(var i=0;i<objArr.length;i++){
                        var objInfo = objArr[i];
                        if(objInfo.proid == productid){
                          if(objInfo.provarid == provarid){
                            var prolistname = objInfo.prolname;
                            console.log(prolistname)
                            if(prolistname){
                              return prolistname;
                            }else{
                              return "not set";
                            }  
                          }else{
                            flagtwo++;
                          }
                        }else{
                          flagno++;
                        }
                    }
                   var sumflag = flagno+flagtwo;
                   if(sumflag==objArr.length){
                     return "not set";
                   }
                  }else{
                     return "not set";
                  }
    }
    function getProCartindex(productid,provarid){
                var ga_proIndex=localStorage.getItem("ga_proIndex");
                if(ga_proIndex){
                   var prolistname = getListCartname(productid,provarid);
                    var objArr=JSON.parse(ga_proIndex);
                      var flagno = 0;
                      for(var i=0;i<objArr.length;i++){
                        var objInfo = objArr[i];
                        if(objInfo.productid == productid && objInfo.prolistname == prolistname){
                            return objInfo.proindex;
                        }else{
                          flagno++;
                        }
                    }
                   if(flagno==objArr.length){
                     return 0;
                   }
                }else{
                   return 0;
                }
  }
    function getProname(productid,provarid,protype){
          var ga_cartProm=localStorage.getItem("ga_cartProm");
           if(ga_cartProm){
                      var objArr=JSON.parse(ga_cartProm);
                     var flagno = 0;
                     var flagtwo = 0;
                      for(var i=0;i<objArr.length;i++){
                        var objInfo = objArr[i];
                        if(objInfo.proid == productid){
                          if(objInfo.provarid == provarid){ 
                            if(protype==1){
                              var promoname = objInfo.promotionname;
                              if(promoname){
                                return promoname;
                              }else{
                                return "not set";
                              }
                            }else if(protype==2){
                              var promoid = objInfo.promotionid;
                              if(promoid){
                                return promoid;
                              }else{
                                 return "not set";
                              }
                            }else{
                              return "not set";
                            }
                          }else{
                            flagtwo++;
                          }
                        }else{
                          flagno++;
                        }
                    }
                   var sumflag = flagno+flagtwo;
                   if(sumflag==objArr.length){
                     return "not set";
                   }
                  }else{
                     return "not set";
                  }
    }
  // 购物车修改数量防抖函数定义
        function debounce(func, delay) {
            let timer;
            return function () {
                if (timer) {
                    clearTimeout(timer);
                }
                timer = setTimeout(() => {
                    func.apply(this, arguments);
                    timer = null;
                }, delay);
            };
        }
        $(".line-item-table__list .line-item").each(function(){
            var precontent = $(this).find(".quantity-selector__input").val();

            precontent = parseInt(precontent, 10);
            precontent = Number.isFinite(precontent) && precontent > 0? precontent : 1;

            var cartnumno = $(this).index();
            cartnumno=cartnumno;
          // 点击删除
            $(this).find(".line-item__remove-button").on('click', function() {
                var product_selection = ".line-item-table__list .click_items"+cartnumno;
                var protitleselection= product_selection + " .product-item-meta__title";
                var pronumselction = product_selection+" .quantity-selector__input";
                var pronumshows= $(pronumselction).val();

                pronumshows = parseInt(pronumshows, 10);
                pronumshows = Number.isFinite(pronumshows) && pronumshows > 0? pronumshows : 1;
              
                var protitleshow = document.querySelector(protitleselection).innerText;
                var prolinameselection= product_selection + " .cart-product-otherinfo .cart-productlistname ";
                var prolistname = document.querySelector(prolinameselection).innerText;
                var proskuselection= product_selection + " .cart-product-otherinfo .cart-productsku ";
                var proskushow = document.querySelector(proskuselection).innerText;
                var prorealskuselection= product_selection + " .cart-product-otherinfo .cart-productrealsku ";
                var prorealskushow = document.querySelector(prorealskuselection).innerText;
                if(prorealskushow=='' || prorealskushow==null || prorealskushow==undefined || prorealskushow.length == 0){
                    prorealskushow = "not set";
                }
                var proidselection= product_selection + " .cart-product-otherinfo .cart-productid ";
                var proidshow = document.querySelector(proidselection).innerText;
                var provariantselection= product_selection + " .product-item-meta__property";
                var provariantshow = document.querySelector(provariantselection).innerText;
                var procatselection= product_selection + " .cart-product-otherinfo .cart-productcat ";
                var procategoryshow = document.querySelector(procatselection).innerText;
                var propriceselection= product_selection + " .ga_price .money";
                var propriceshow = document.querySelector(propriceselection).innerText.replace(/[^0-9.]/g, '');
                var prosubprice = pronumshows*propriceshow;
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    "event":  "dle_remove_from_cart",
                    "ecommerce":  {
                        "currency": "USD",
                        "value": prosubprice,
                        "items": [
                            {
                                "item_name": protitleshow,
                                "item_id": proidshow,
                                "product_sku": prorealskushow,
                                "price": propriceshow,
                                "item_category": procategoryshow,
                                "item_variant": provariantshow,
                                "item_list_name": getListCartname(proidshow,proskushow),
                                "index": getProCartindex(proidshow,proskushow),
                                "quantity": pronumshows,
                                "currency": "USD"
                            }
                        ]
                    }
                });
            })
          // 点击数量
            $(this).find(".quantity-selector__input").on('input', debounce(function () {
                var aftercontent = $(this).val();
                aftercontent = parseInt(aftercontent, 10);
                aftercontent = Number.isFinite(aftercontent) && aftercontent > 0? aftercontent : 1;
              
                var product_selection = ".line-item-table__list .click_items"+cartnumno;
              console.log(product_selection);
                var protitleselection= product_selection + " .product-item-meta__title";
                var protitleshow = document.querySelector(protitleselection).innerText;
                var prolinameselection= product_selection + " .cart-product-otherinfo .cart-productlistname ";
                var prolistname = document.querySelector(prolinameselection).innerText;
                var proskuselection= product_selection + " .cart-product-otherinfo .cart-productsku ";
                var proskushow = document.querySelector(proskuselection).innerText;
                var prorealskuselection= product_selection + " .cart-product-otherinfo .cart-productrealsku ";
                var prorealskushow = document.querySelector(prorealskuselection).innerText;
                if(prorealskushow=='' || prorealskushow==null || prorealskushow==undefined || prorealskushow.length == 0){
                    prorealskushow = "not set";
                }
                var proidselection= product_selection + " .cart-product-otherinfo .cart-productid ";
                var proidshow = document.querySelector(proidselection).innerText;
                var provariantselection= product_selection + " .product-item-meta__property";
                var provariantshow = document.querySelector(provariantselection).innerText;
                var procatselection= product_selection + " .cart-product-otherinfo .cart-productcat ";
                var procategoryshow = document.querySelector(procatselection).innerText;
                var propriceselection= product_selection + " .ga_price .money";
                var propriceshow = document.querySelector(propriceselection).innerText.replace(/[^0-9.]/g, '');
                if (aftercontent != precontent) {
                    var subtotal = aftercontent*propriceshow;
                    if(aftercontent>precontent){
                        var leftnumcon = aftercontent-precontent;
                        subtotal = leftnumcon*propriceshow;
                        dataLayer.push({ ecommerce: null });
                        dataLayer.push({
                            "event":  "dle_add_to_cart",
                            "ecommerce":  {
                                "currency": "USD",
                                "value": subtotal,
                                "items": [
                                    {
                                        "item_name": protitleshow,
                                        "item_id": proidshow,
                                        "product_sku": prorealskushow,
                                        "price": propriceshow,
                                        "item_category": procategoryshow,
                                        "item_variant": provariantshow,
                                        "item_list_name": getListCartname(proidshow,proskushow),
                                        "promotion_name": getProname(proidshow,provariantshow,1),
                                        "promotion_id": getProname(proidshow,provariantshow,2),
                                        "index": getProCartindex(proidshow,proskushow),
                                        "quantity": leftnumcon,
                                        "currency": "USD"
                                    }
                                ]
                            }
                        });
                    }
                    if(aftercontent<precontent){
                        var leftnumcon = precontent-aftercontent;
                        subtotal = leftnumcon*propriceshow;
                        dataLayer.push({ ecommerce: null });
                        dataLayer.push({
                            "event":  "dle_remove_from_cart",
                            "ecommerce":  {
                                "currency": "USD",
                                "value": subtotal,
                                "items": [
                                    {
                                        "item_name": protitleshow,
                                        "item_id": proidshow,
                                        "product_sku": prorealskushow,
                                        "price": propriceshow,
                                        "item_category": procategoryshow,
                                        "item_variant": provariantshow,
                                        "item_list_name": getListCartname(proidshow,proskushow),
                                        "index": getProCartindex(proidshow,proskushow),
                                        "quantity": leftnumcon,
                                        "currency": "USD"
                                    }
                                ]
                            }
                        });
                    }
                }
            }, 1000)); 
        })
    }


  // 普通事件
        // 释放删除ga_prInfo
        function sendRemPromoinfo(){
            var ga_prInfo=localStorage.getItem("ga_prInfo");
            if(ga_prInfo){
                localStorage.removeItem("ga_prInfo");
            }
        }

        window.dataLayer=window.dataLayer||[];
        // search
        $(".header__inline-navigation .predictive-search__form  .predictive-search__input").on("focus",function(){
            dataLayer.push({
                "event_category": pagegrounp,
            "event_action": "click",
                "event_label": "search",
                "event": "cme_top_nav"
        });
        })
        // 手机 search
        $(".header__icon-list .head_ga_search_wap").on("click",function(){
            dataLayer.push({
                "event_category": pagegrounp,
            "event_action": "click",
                "event_label": "search",
                "event": "cme_top_nav"
        });
        })
        // logo
        $(".header__logo .header__logo-image").on("click",function(){
            dataLayer.push({
                "event_category": pagegrounp,
            "event_action": "click",
                "event_label": "logo",
                "event": "cme_top_nav"
        });
        })
        // account
        $(".header__icon-list .head_ga_customer").on("click",function(){
            dataLayer.push({
                "event_category": pagegrounp,
            "event_action": "click",
                "event_label": "account",
                "event": "cme_top_nav"
        });
        })
        // 手机 account
        $(".header__icon-list .head_ga_customer_wap").on("click",function(){
            dataLayer.push({
                "event_category": pagegrounp,
            "event_action": "click",
                "event_label": "account",
                "event": "cme_top_nav"
        });
        })
        // cart
        $(".header__icon-list .head_ga_cart").on("click",function(){
            dataLayer.push({
                "event_category": pagegrounp,
            "event_action": "click",
                "event_label": "cart",
                "event": "cme_top_nav"
        });
        })
        jQuery(".header__linklist").find(".header__linklist-item").each(function(){
            $(this).find(".nav-dropdown__item .nav-dropdown__link").each(function(){
                $(this).on('click',function(e){
                    e.stopPropagation();
                    var label = $(this).text().trim();
                    sendRemPromoinfo();
                    dataLayer.push({
                        "event_category": pagegrounp,
                        "event_action": "click",
                        "event_label": "L2::"+label,
                        "event": "cme_top_menu"
                });
                })
            })
            $(this).on('click',function(){
                var label = $(this).children("a").text().trim();
                sendRemPromoinfo();
                dataLayer.push({
                    "event_category": pagegrounp,
                    "event_action": "click",
                    "event_label": "L1::"+label,
                    "event": "cme_top_menu"
            });
            })
        })
        $("#mobile-menu-drawer .menu_ga_wap").on("click","a.mobile-nav__link",function(){
            var label =$(this).text().trim();
            if(label == "Log in"){
                return null;
            }
            if($(this).hasClass("heading")){
                label = "L1::"+label;
            }else{
                label = "L2::"+label;
            }
            dataLayer.push({
                "event_category":pagegrounp,
            "event_action": "click",
                "event_label": label,
                "event": "cme_top_menu"
        })
        })
        $(".hu-multicolumn .multicolumn-list .multicolumn-list__item .full-unstyled-link").on("click",function(){
            var label = $(this).find(".multicolumn-card__title").text().trim();
            dataLayer.push({
                "event_categoty":"home_page",
                "event_action": "menu_click",
                "event_label": label,
                "event": "cme_category_click"
            })
        })
        jQuery(".footer__item-list .footer__item").each(function(){
            var label = $("this").find(".footer__item-title").text().trim();
            $(this).find(".linklist__item a").on('click',function(){
                dataLayer.push({
                    "event_category": pagegroump,
                "event_action": "click",
                    "event_label": label+"::"+$(this).text().trim(),
                    "event": "cme_footer_nav"
            });
            })
        })
        jQuery(".section__color-wrapper .ga_feat_coll").each(function(){
            var action = $(this).find("h2.p_heading").text().trim();
            var label = $(this).find(".p_view .button--primary").text().trim();
            var myurl = window.location.href;
            if(myurl.includes('/black-friday-sale')){
                var mypage= "pageBFsale";
            }else{
                var mypage= "home_page";
            }
            $(this).find(".p_view .button--primary").on('click',function(){
                dataLayer.push({
                    "event_categoty":mypage,
                    "event_action": action+"_click",
                    "event_label": label,
                    "event": "cme_click"
                })
            })
        }) 

  




  
})